export const AMERICAN_MORTGAGE_INTEREST_RATE = 6.79;
export const CONSUMER_LOAN_FALLBACK_INTEREST_RATE = 4.8;
export const PENSION_ANNUITY_INTEREST_RATE = 5;
export const PENSION_ANNUITY_WAITING_YEARS = 5;
export const SAVINGS_INTEREST_RATE = 5;

export const MORTGAGE_LIMITS = {
	propertyPriceMin: 250_000,
	propertyPriceMax: 30_000_000,
	loanCap: 27_000_000,
	loanRatio: 0.9,
	loanStep: 50_000,
	yearsMin: 3,
	yearsMax: 30,
};

export const AMERICAN_MORTGAGE_LIMITS = {
	propertyPriceMin: 450_000,
	propertyPriceMax: 25_000_000,
	loanMin: 300_000,
	loanCap: 15_000_000,
	loanRatio: 0.7,
	loanStep: 50_000,
	yearsMin: 5,
	yearsMax: 20,
};

export const REFINANCING_LIMITS = {
	propertyPriceMin: 250_000,
	propertyPriceMax: 30_000_000,
	monthlyPaymentMax: 150_000,
	interestMax: 10,
	yearsMin: 3,
	yearsMax: 40,
	paidPeriodMin: 1,
};

export const CONSUMER_LOAN_LIMITS = {
	loanMin: 5_000,
	loanMax: 1_000_000,
	yearsMin: 1,
	yearsMax: 15,
};

export const PENSION_ANNUITY_LIMITS = {
	annuityMax: 999_999,
	depositMax: 9_500_000,
	durationMin: 1,
	durationMax: 30,
	yearsUntilMin: 6,
	yearsUntilMax: 40,
};

export const SAVINGS_LIMITS = {
	targetAmountMin: 10_000,
	targetAmountMax: 5_000_000,
};

export const CHILDREN_SAVINGS_LIMITS = {
	yearsMin: 1,
	yearsMax: 26,
};

export const GOAL_ACHIEVE_LIMITS = {
	yearsMin: 1,
	yearsMax: 10,
};
